// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/Instance/Instance.css */

.instance-headi {
    color: white;
    text-align: center;
    font-size: 1.8rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    margin-bottom: 2rem;
    margin-top: 1rem;
}

.instance-headi:hover {
    color: #EF6F53;
}

.instances-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 1rem;
}

.current-instances {
    background-color: rgba(239, 111, 83, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 2rem;
}

.current-instances h3 {
    color: white;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    text-align: center;
}

.instance-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.1);
    padding: 1rem 1.5rem;
    margin-bottom: 0.75rem;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.instance-info {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.connection-button {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 140px;
    text-align: center;
}

.connection-button.connected {
    background-color: #4CAF50;
    color: white;
    cursor: default;
}

.connection-button.disconnected {
    background-color: #ff9800;
    color: white;
}

.connection-button.disconnected:hover {
    background-color: #f57c00;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.connection-button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.instance-item:hover {
    transform: translateX(5px);
    background-color: rgba(239, 111, 83, 0.2);
}

.instance-item span {
    color: white;
    font-size: 1rem;
}

.instance-item .created-at {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.9rem;
}

.form-groupie {
    display: flex;
    align-items: center;
    background-color: #EF6F53;
    padding: 0.75rem 1rem;
    width: 100%;
    margin: 1rem 0;
    border-radius: 10px;
}

.form-groupie label {
    flex: 40% 1;  
    text-align: left;  
    font-size: 1rem;
    color: white;
    font-weight: 600;
    margin-right: 1rem;
}

.form-groupie input {
    flex: 60% 1;  
    padding: 0.5rem;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    outline: none;
    text-align: left;
    font-weight: 400;
    background-color: rgba(255, 255, 255, 0.9);
}

.form-groupie:hover {
    background-color: #d15846;
}

.form-instance button {
    background-color: white;
    color: #364c63;
    border: none;
    width: 100%;
    max-width: 200px;
    margin: 1rem auto;
    padding: 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: block;
}

.form-instance button:hover {
    background-color: #d15846;
    color: white;
    transform: translateY(-2px);
}

.continue-button {
    background-color: #4CAF50;
    color: white;
    border: none;
    width: 100%;
    max-width: 300px;
    margin: 2rem auto;
    padding: 1rem;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.continue-button:hover {
    background-color: #45a049;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.continue-button:disabled,
.form-instance button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.alertttt {
    color: white;
    margin-top: 2rem;
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    padding: 1rem;
    background-color: rgba(239, 111, 83, 0.2);
    border-radius: 8px;
}

.error {
    color: #ff4444;
    margin-top: 1rem;
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    padding: 1rem;
    background-color: rgba(255, 68, 68, 0.1);
    border-radius: 8px;
}

.loading {
    color: #4CAF50;
    margin-top: 1rem;
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    padding: 1rem;
    background-color: rgba(76, 175, 80, 0.1);
    border-radius: 8px;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% { opacity: 0.6; }
    50% { opacity: 1; }
    100% { opacity: 0.6; }
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/Instance/Instance.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,0CAA0C;IAC1C,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAS;IACT,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAS;IACT,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,KAAK,YAAY,EAAE;IACnB,MAAM,UAAU,EAAE;IAClB,OAAO,YAAY,EAAE;AACzB","sourcesContent":["/* src/components/routes/Forms/Instance/Instance.css */\n\n.instance-headi {\n    color: white;\n    text-align: center;\n    font-size: 1.8rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    margin-bottom: 2rem;\n    margin-top: 1rem;\n}\n\n.instance-headi:hover {\n    color: #EF6F53;\n}\n\n.instances-container {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 1rem;\n}\n\n.current-instances {\n    background-color: rgba(239, 111, 83, 0.1);\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n}\n\n.current-instances h3 {\n    color: white;\n    font-size: 1.2rem;\n    margin-bottom: 1rem;\n    text-align: center;\n}\n\n.instance-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.1);\n    padding: 1rem 1.5rem;\n    margin-bottom: 0.75rem;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n}\n\n.instance-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.connection-button {\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: 6px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    min-width: 140px;\n    text-align: center;\n}\n\n.connection-button.connected {\n    background-color: #4CAF50;\n    color: white;\n    cursor: default;\n}\n\n.connection-button.disconnected {\n    background-color: #ff9800;\n    color: white;\n}\n\n.connection-button.disconnected:hover {\n    background-color: #f57c00;\n    transform: translateY(-2px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.connection-button:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.instance-item:hover {\n    transform: translateX(5px);\n    background-color: rgba(239, 111, 83, 0.2);\n}\n\n.instance-item span {\n    color: white;\n    font-size: 1rem;\n}\n\n.instance-item .created-at {\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 0.9rem;\n}\n\n.form-groupie {\n    display: flex;\n    align-items: center;\n    background-color: #EF6F53;\n    padding: 0.75rem 1rem;\n    width: 100%;\n    margin: 1rem 0;\n    border-radius: 10px;\n}\n\n.form-groupie label {\n    flex: 40%;  \n    text-align: left;  \n    font-size: 1rem;\n    color: white;\n    font-weight: 600;\n    margin-right: 1rem;\n}\n\n.form-groupie input {\n    flex: 60%;  \n    padding: 0.5rem;\n    font-size: 1rem;\n    border: none;\n    border-radius: 5px;\n    outline: none;\n    text-align: left;\n    font-weight: 400;\n    background-color: rgba(255, 255, 255, 0.9);\n}\n\n.form-groupie:hover {\n    background-color: #d15846;\n}\n\n.form-instance button {\n    background-color: white;\n    color: #364c63;\n    border: none;\n    width: 100%;\n    max-width: 200px;\n    margin: 1rem auto;\n    padding: 0.75rem;\n    font-size: 1rem;\n    font-weight: 600;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: block;\n}\n\n.form-instance button:hover {\n    background-color: #d15846;\n    color: white;\n    transform: translateY(-2px);\n}\n\n.continue-button {\n    background-color: #4CAF50;\n    color: white;\n    border: none;\n    width: 100%;\n    max-width: 300px;\n    margin: 2rem auto;\n    padding: 1rem;\n    font-size: 1.1rem;\n    font-weight: 600;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: block;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.continue-button:hover {\n    background-color: #45a049;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.continue-button:disabled,\n.form-instance button:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.alertttt {\n    color: white;\n    margin-top: 2rem;\n    font-size: 1rem;\n    font-weight: 600;\n    text-align: center;\n    padding: 1rem;\n    background-color: rgba(239, 111, 83, 0.2);\n    border-radius: 8px;\n}\n\n.error {\n    color: #ff4444;\n    margin-top: 1rem;\n    font-size: 1rem;\n    font-weight: 600;\n    text-align: center;\n    padding: 1rem;\n    background-color: rgba(255, 68, 68, 0.1);\n    border-radius: 8px;\n}\n\n.loading {\n    color: #4CAF50;\n    margin-top: 1rem;\n    font-size: 1rem;\n    font-weight: 600;\n    text-align: center;\n    padding: 1rem;\n    background-color: rgba(76, 175, 80, 0.1);\n    border-radius: 8px;\n    animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n    0% { opacity: 0.6; }\n    50% { opacity: 1; }\n    100% { opacity: 0.6; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
